export default {
	"share.FailedToGetInformation": "Failed to get information",
	"share.generatingPoster": "generating poster",
	"share.LongPressThePictureToShare": "Long press the picture to share",
	"share.LimitPrice": "Limit price",
	"share.LimitedGift": "Limited gift"
}